import { FunctionalComponent, h } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'

import { PersonAvatar } from '../call/avatar/ui'
import { ICompany, IContact } from '../call/types'
import { colors } from '../tailwind'
import { hexColorForString } from './color'
import { classes, colorClasses } from './css'

export function getInitialsUrl(
  name: string,
  bgColor = colors['surface-higher'].slice(1),
  textColor = colors['surface-base'].slice(1)
) {
  const url = new URL('https://ui-avatars.com/api/')
  url.searchParams.append('name', name.replace(' ', '+'))
  url.searchParams.append('background', bgColor)
  url.searchParams.append('color', textColor)
  return url.toString()
}

export const PlaceholderCompanyAvatar: FunctionalComponent<JSXBase.IntrinsicElements['div']> = ({
  class: className = '',
  ...attrs
}) => (
  <div
    class={`object-contain flex-shrink-0 overflow-hidden rounded ${className}`}
    style={{ width: '1em', height: '1em' }}
    {...attrs}
  >
    <ui-icon icon='person' class='text-glyph-lightest' />
  </div>
)

export const CompanyAvatar: FunctionalComponent<{ company: ICompany } & JSXBase.IntrinsicElements['img']> = ({
  company,
  class: className = '',
  ...attrs
}) => {
  return (
    company &&
    (company.icon_url || company.name) && (
      <img
        class={`object-contain flex-shrink-0 overflow-hidden rounded ${className}`}
        style={{ width: '1em', height: '1em' }}
        src={company.icon_url || getInitialsUrl(company.name)}
        {...attrs}
      />
    )
  )
}

export const AttendeeAvatar: FunctionalComponent<
  { attendee: IContact; border?: boolean } & JSXBase.IntrinsicElements['div']
> = ({ attendee, border = false, class: className }) => {
  const color = hexColorForString(attendee.name || attendee.email)
  return (
    <PersonAvatar
      email={attendee.email}
      name={attendee.name}
      class={`
        ${className}
        ${classes(border, 'border-2')}
        ${colorClasses({ border: color })}
      `}
    />
  )
}

export const ObjectTitle: FunctionalComponent<JSXBase.IntrinsicElements['dl']> = (
  { class: className = '', ...attrs },
  [title, subtitle]
) => (
  <dl class={`${className} flex flex-col`} {...attrs}>
    <dt class='flex flex-col font-bold' style={{ lineHeight: '1.4' }}>
      {title}
    </dt>
    <dd class='flex flex-col font-medium text-glyph-lighter' style={{ fontSize: '.87em', lineHeight: '1.2' }}>
      {subtitle}
    </dd>
  </dl>
)
